/**
 * Environment-based logging utility
 * Only logs during development, silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  log: isDevelopment ? console.log : () => {},
  warn: isDevelopment ? console.warn : () => {},
  error: isDevelopment ? console.error : () => {},
  debug: isDevelopment ? console.debug : () => {},
  info: isDevelopment ? console.info : () => {}
};

export default logger;
